module.exports = __webpack_public_path__ + "static/media/melissa8.7b172711.jpg";